export class ValidaTelefone {
    public static LenghtTest(phone: string): boolean {
        let replaceTelefone = phone.replace(/\D/g, '');
        
        if(replaceTelefone.length === 11) return true;
        return false;
    }
}